
const DEFAULT_COUNTRY = "Sweden";

export default class Product {
    constructor(product) {
        product = product || {};

        this.barcode = product.barcode || "";
        this.uid = product.uid || "";
        this.name = product.name || "";
        this.description = product.description || "";
        this.typeofgarment = product.typeofgarment || "";
        this.mintcondition = product.mintcondition || "";
        this.buyingprice = product.buyingprice || "";
        this.targetsalesprice = product.targetsalesprice || "";
        this.finalsalesprice = product.finalsalesprice || "";
        this.sizes = product.sizes || "";
        this.currency = product.currency || "USD";
        this.washingdetergent = product.washingdetergent || [];
        this.gender = product.gender || "";
        this.materialdata = product.materialdata || {materials: [],selectedMaterial: ''};
        this.yearofproduction = product.yearofproduction || 2024;
        this.sold = product.sold || false;
        this.platformsold = product.platformsold || "";
        this.beforewashImagesURL = product.beforewashImagesURL || {front:[], back:[]};
        this.afterwashImagesURL = product.afterwashImagesURL || {front:[], back:[]};
        this.brand = product.brand || "";
        this.cycles = product.cycles || 0;
        this.excluded_customer = product.excluded_customer || "";
        this.category = product.category || "";
        this.location = product.location || "";
        this.season = product.season || "";
        this.size = product.size || "";
        this.status = product.status || "";
        this.supplier = product.supplier || "";
        this.washing = product.washing || "";
        this.item_family = product.item_family || "Basic";
        this.currentUser = product.currentUser || null;
        this.currentBox = product.currentBox || null;
        this.model = product.model || null;
        this.model_ref = product.model_ref || null;


        this.color = product.color || [];
        this.details = product.details || [];
        this.imageURLs = product.imageURLs || [];
        this.attributes = product.attributes || [];
        this.tags = product.tags || [];
        this.cuts = product.cuts || [];
        this.market = product.market || DEFAULT_COUNTRY;
    }

    toJSON() {
        return {
            barcode: this.barcode,
            name: this.name,
            uid: this.uid,
            description: this.description,
            typeofgarment:this.typeofgarment,
            mintcondition:this.mintcondition,
            buyingprice:this.buyingprice,
            targetsalesprice:this.targetsalesprice,
            finalsalesprice:this.finalsalesprice,
            sizes:this.sizes,
            currency:this.currency,
            washingdetergent:this.washingdetergent,
            gender:this.gender,
            materialdata:this.materialdata,
            yearofproduction:this.yearofproduction,
            sold:this.sold,
            platformsold:this.platformsold,
            beforewashImagesURL:this.beforewashImagesURL,
            afterwashImagesURL:this.afterwashImagesURL,
            brand: this.brand,
            color: this.color,
            cycles: this.cycles,
            excluded_customer: this.excluded_customer,
            category: this.category,
            location: this.location,
            season: this.season,
            size: this.size,
            details: this.details,
            status: this.status,
            supplier: this.supplier,
            washing: this.washing,
            item_family: this.item_family,
            imageURLs: this.imageURLs,
            attributes: this.attributes,
            model: this.model,
            model_ref: this.model_ref,
            tags: this.tags,
            cuts: this.cuts,
            currentUser: this.currentUser,
            currentBox: this.currentBox,
            market: this.market,
        };
    }
}
